<template>
    <section v-if="(onlyView && this.todosDone != 100 && Number.isInteger(this.todosDone)) || !onlyView" class="form-group-checklist todoapp">
        <header class="panel row" :class="todos.length > 0 ? '' : 'mb-2'" v-cloak>
            <h3 class="col-9 pr-0" :class="this.todosDone != 100 && this.currentTimelineStateId > this.timelineStateId ? 'headline-warning' : ''">
                <div class="w-70 float-left" :class="todos.length && remaining == 0 ? 'remaining-title remaining-title-done' : ''">
                    {{ this.timelineStateName.value }}

                    <span v-if="this.currentTimelineStateId > 6 && this.timelineStateId == 7 && this.deadlineFrom">({{ this.$t("tasks_to_be_done_before") }}{{ this.deadlineFrom }})</span>
                    <span v-else-if="this.currentTimelineStateId > 6 && this.timelineStateId == 8 && this.deadlineFrom">({{ this.deadlineFrom }}) </span>
                    <span v-else-if="this.currentTimelineStateId > 6 && this.timelineStateId > 8 && this.timelineStateId < 13 && this.deadlineFrom">({{ this.deadlineFrom }} – {{ this.deadlineTo }})</span>
                </div>

                <div v-if="this.todosDone != 100 && this.currentTimelineStateId > this.timelineStateId" class="d-none d-md-block btn btn-primary btn-sm badge-counter badge-counter-large badge-counter-warning float-right" style="margin-top:-2px;">Po termínu</div>
            </h3>
            <div class="col-3 pl-0 text-right">
                <span v-show="todos.length && remaining > 0" class="todo-count">
                    <span v-if="!onlyView" class="remaining-title">{{ this.$t("done") }} </span>
                    <div class="btn btn-primary btn-sm badge-counter badge-counter-large" :class="this.todosDone != 100 ? 'badge-counter-warning' : ''">{{ todosDone }} %</div>
                </span>
                <span v-show="todos.length && remaining == 0" class="todo-count">
                    <span v-if="!onlyView" class="remaining-title remaining-title-done">{{ this.$t("done") }} </span>
                    <div class="btn btn-primary btn-sm badge-counter badge-counter-large" :class="this.todosDone == 100 ? 'badge-counter-done' : ''">{{ todosDone }} %</div>
                </span>
            </div>
        </header>

        <section v-if="!onlyView || (onlyView && todos.length)" class="main" v-show="todos.length" v-cloak>
            <ul class="todo-list">
                <li v-for="todo in filteredTodos" class="todo row ml-3 mr-3" :key="todo.id_order" :class="{ completed: todo.completed, editing: todo == editedTodo }">
                    <div class="view col-sm-12 pl-0" :class="onlyView ? 'col-md-12' : 'col-md-7'">
                        <input class="toggle" type="checkbox" v-model="todo.completed" @change="changeCheckbox(todo)" />
                        <label v-if="!onlyView" @click="editTodo(todo)">{{ todo.name }}</label>
                        <label v-else-if="onlyView">{{ todo.name }}</label>
                        <button v-if="!onlyView" class="copy" @click="copyTodo(todo)" :title="$t('click_to_copy')"></button>
                        
                    </div>
                    <input class="toggle" type="checkbox" v-model="todo.completed" @change="changeCheckbox(todo)" />
                    <textarea v-if="!onlyView" :rows="todo.name.length < 100 && !isMobile ? 1 : 2" class="edit col-sm-12 col-md-7 pl-0" v-model.lazy="todo.name" v-todo-focus="todo == editedTodo" @blur="doneEdit(todo)" @keyup.enter="doneEdit(todo)" @keyup.esc="cancelEdit(todo)"></textarea>
                    <button v-if="!onlyView" class="destroy" @click="removeTodo(todo)" :title="$t('delete')"></button>

                    <div v-if="!onlyView" class="col-sm-12 col-md-3 text-center p-0 pr-0 mb-0 todo-user-select">
                        <app-icon v-if="!todo.user_id" :name="'user-plus'" width="25" height="25" />
                        <app-input v-if="userOptions" class="col-sm-12 pl-0 pr-0" type="smart-select" v-model="todo.user_id" :list="userOptions" :label="$t('assignee_task')" :required="false" @input="editDeadline(todo)"/>
                    </div>
                    
                    <div v-if="!onlyView" class="col-sm-12 col-md-2 text-center p-0 pr-0 mb-0">
                        <span v-if="!todo.deadline">
                            <app-input class="col-sm-12" type="date" :dateMode="'date'" v-model="todo.deadline" :placeholder="''" @input="editDeadline(todo)"/>
                        </span>
                        <span v-else class="filled-deadline">
                            <app-input class="col-sm-12" type="date" :dateMode="'date'" v-model="todo.deadline" :placeholder="''" @input="editDeadline(todo)"/>
                        </span>
                    </div>
                    <div v-else-if="todo.deadline" class="col-sm-12 col-md-12 small text-muted text-right">
                      {{ $t('change_state_to')+' '+formatDate(todo.deadline) }}
                    </div>
                </li>
            </ul>
        </section>
        <section v-else class="text-center">
            {{ this.$t("nothing_to_show_here_tasks") }}
        </section>

        <footer v-if="!onlyView">
            <input class="new-todo" autocomplete="off" :placeholder="$t('add_new_task_placeholder')" v-model="newTodo" @keyup.enter="addTodo" />
            <button class="new-todo-button" @click="addTodo">+ {{ this.$t("add") }}</button>
        </footer>

        <div v-if="(!this.deadline || !this.deadline) && this.currentTimelineStateId > 6 && !onlyView" class="text-center mt-3">
            <strong> <app-icon :name="'alert-circle'" width="20" height="20" /> {{ this.$t("onboarding_start_date_not_entered") }} </strong>
        </div>

        <ul v-if="todos.length > 0 && remaining > 0" class="filters mt-3 text-center">
            <li v-if="visibility == 'active'" class="pr-0">
                <a :class="{ selected: visibility == 'all' }" @click.prevent="changeVisibility('all')">{{ this.$t("show_all") }}</a>
            </li>
            <li v-if="visibility == 'all'" class="pr-0">
                <a :class="{ selected: visibility == 'active' }" @click.prevent="changeVisibility('active')">{{ this.$t("only_uncompleted") }}</a>
            </li>
        </ul>
    </section>
</template>

<script>
// localStorage.clear();
const presetValues = [
    {
        title: "Wake up at 5am",
        completed: true,
    },
    {
        title: "Learn how to use Vue.js",
        completed: false,
    },
    {
        title: "Drink coffee",
        completed: false,
    },
];
// Use localStorage
const STORAGE_KEY = "todo-app";
const todoStorage = {
    fetch: function() {
        var todos = JSON.parse(localStorage.getItem(STORAGE_KEY)) || presetValues;
        todos.forEach(function(todo, index) {
            todo.id = index;
        });
        todoStorage.uid = todos.length;
        return todos;
    },
    save: function(todos) {
        localStorage.setItem(STORAGE_KEY, JSON.stringify(todos));
    },
};

// visibility filters
var filters = {
    all: function(todos) {
        return todos;
    },
    active: function(todos) {
        return todos.filter(function(todo) {
            return !todo.completed;
        });
    },
    completed: function(todos) {
        return todos.filter(function(todo) {
            return todo.completed;
        });
    },
};

import AppLibrary from "../../../../Helpers/AppLibrary";
import CoreLibrary from "../../../../../core/helpers/CoreLibrary.js";

export default {
    name: "ChecklistForm",
    extends: AppLibrary,
    props: {
        candidateId: {
            type: String,
            default: 1,
        },
        timelineStateId: {
            type: Number,
            default: 1,
        },
        currentTimelineStateId: {
            type: Number,
            default: 1,
        },
        timelineStateName: {
            type: [Object, String],
        },
        typeId: {
            type: Number,
            default: 1,
        },
        userOptions: {
            type: Array,
        },
        eventDate: {
            type: String,
        },
        checklistTasks: {
            type: Array,
        },
        onlyView: {
            type: Boolean,
            default: false,
        },
        preview: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            todos: [],
            todoStorage: [],
            newTodo: "",
            editedTodo: null,
            todosDone: [],
            visibility: "all",
            deadline: "",
            deadlineTo: "",
            deadlineFrom: "",
            isMobile: true,
            windowWidth: window.innerWidth,
        };
    },

    // watch todos change for localStorage persistence
    watch: {
        todos: {
            handler: function(todos, oldVal) {
                if (todos) {
                    let todosDonePercentage = this.todos.filter((t) => t.completed == true);
                    this.todosDone = Math.round((todosDonePercentage.length / this.todos.length) * 100);
                }
            },
            deep: true,
        },
        checklistTasks: {
            handler(val) {
                if (val.length > 0) {
                    console.log('change '+val);
                } else {
                    this.todoStorage.uid = 0;
                }
            },
        },
        eventDate: {
            handler(val) {
                if (this.eventDate) {
                    // console.log('change '+this.checklistTasks);
                } else {
                }
            },
        },
        todosDone: {
            handler(val) {
                if (this.eventDate) {
                    // console.log('change '+this.checklistTasks);
                } else {
                }
            },
        },
    },

    // computed properties
    // http://vuejs.org/guide/computed.html
    computed: {
        filteredTodos: function() {
            return filters[this.visibility](this.todos);
        },
        remaining: function() {
            return filters.active(this.todos).length;
        },
        allDone: {
            get: function() {
                return this.remaining === 0;
            },
            set: function(value) {
                this.todos.forEach(function(todo) {
                    todo.completed = value;
                });
            },
        },
    },

    created() {
        this.unwatchIsLiveProp = this.$watch("checklistTasks", (newVal) => {
            if (newVal) {
                this.getTodos();
                this.unwatchIsLiveProp();
            }
        });

        this.unwatchIsEventDateProp = this.$watch("eventDate", (newVal) => {
            if (newVal) {
                this.getDeadline();
                this.unwatchIsEventDateProp();
            }
        });

        if(this.preview){
            this.getTodos();
            this.getDeadline();
            this.unwatchIsEventDateProp();
            this.unwatchIsEventDateProp();
        }
    },
    mounted() {
      this.isMobile = this.windowWidth < 1150 ? true : false;

      let _this = this;
      setTimeout(function() {
        _this.getDeadline();
      }, 200);
    },

    filters: {
        pluralize: function(n) {
            return n === 1 ? "úkol" : "úkoly";
        },
    },

    methods: {
        formatDate(date){
            return date ? moment(date).format("DD. MM.") : '';
        },
        changeVisibility(filter) {
            this.visibility = filter;
        },

        getTodos() {
            // Get this.checklistTasks
            // var todos = JSON.parse(localStorage.getItem(STORAGE_KEY)) || presetValues;

            var todos = this.checklistTasks;

            // Set temporary ID (for sorting and addTodo)
            todos.forEach(function(todo, index) {
                todo.id_order = index;
            });

            // Set temporary ID (to add task to bottom), set real ID on save on side of DB (do not save this value) <––– !!!
            todoStorage.uid = todos.length;

            this.todoStorage.uid = todos.length;

            this.todos = todos;
        },

        getDeadline() {
            if (this.eventDate) {
                if (this.timelineStateId == 7) {
                    this.deadline = moment(this.eventDate)
                        .subtract(1, "days")
                        .format("YYYY-MM-DD");
                    this.deadlineFrom = moment(this.eventDate)
                        .subtract(1, "days")
                        .format("D. M.");
                } else if (this.timelineStateId == 8) {
                    this.deadline = moment(this.eventDate).format("YYYY-MM-DD");
                    this.deadlineFrom = moment(this.eventDate).format("D. M.");
                } else if (this.timelineStateId == 9) {
                    this.deadline = moment(this.eventDate)
                        .add(1, "days")
                        .format("YYYY-MM-DD");
                    this.deadlineFrom = moment(this.eventDate)
                        .add(1, "days")
                        .format("D. M.");
                    this.deadlineTo = moment(this.eventDate)
                        .subtract(1, "days")
                        .add(3, "months")
                        .format("D. M.");
                } 
            }
        },

        addTodo: function() {
            var value = this.newTodo && this.newTodo.trim();
            if (!value) {
                return;
            }
            this.todos.push({
                id_order: this.todoStorage.uid++,
                name: value,
                candidate_id: this.candidateId,
                deadline: this.deadline,
                timeline_state: this.timelineStateId,
                type: this.typeId,
                status: 1,
                completed: false,
            });
            this.saveNewTodo(this.todos[this.todos.length - 1]);
            this.newTodo = "";
        },

        changeCheckbox(todo) {
            this.saveTodo(todo);

            if (todo.completed && !this.onlyView) {
                let _this = this;
                setTimeout(function() {
                    if (_this.todosDone == 100) {
                        $(".checklist-done-animation").addClass("show");
                        $(".todoapp").addClass("overlay");

                        _this.changeCheckboxOverlay();
                    }
                }, 200);
            }
        },
        changeCheckboxOverlay() {
            if (!this.onlyView) {
                setTimeout(function() {
                    $(".todoapp").removeClass("overlay");
                }, 2000);
                setTimeout(function() {
                    $(".checklist-done-animation").removeClass("show");
                }, 2500);
            }
        },

        copyTodo: function(todo) {
            let response = this.todos[this.todos.indexOf(todo)].name;
            navigator.clipboard.writeText(response);
            this.$toastr.s("Text úkolu zkopírován");
        },

        removeTodo: function(todo) {
            this.todos.splice(this.todos.indexOf(todo), 1);
            this.deleteTodo(todo);
        },

        editDeadline(todo){
          this.beforeEditCache = todo.name;
          this.editedTodo = todo;
        },

        editTodo: function(todo) {
            this.beforeEditCache = todo.name;
            this.editedTodo = todo;
        },

        doneEdit: function(todo) {
            if (!this.editedTodo) {
                return;
            }
            console.log("test B "+todo);
            this.editedTodo = null;
            todo.name = todo.name.trim();
            if (!todo.name) {
                this.removeTodo(todo);
            }
  
            this.saveTodo(todo);
        },

        cancelEdit: function(todo) {
            this.editedTodo = null;
            todo.name = this.beforeEditCache;
        },

        removeCompleted: function() {
            this.todos = filters.active(this.todos);
        },

        deleteTodo(todo) {
            this.axiosPatch({
                url: "admin/app/checklist-delete",
                data: todo,
            })
                .then((response) => {})
                .finally(() => {});
        },
        saveTodo(todo) {
            this.axiosPatch({
                url: "admin/app/checklist-edit",
                data: todo,
            })
                .then((response) => {})
                .finally(() => {});
        },
        saveNewTodo(todo) {
            this.axiosPost({
                url: "admin/app/checklist-add",
                data: todo,
            })
                .then((response) => {
                    this.todos[this.todos.length - 1].id = response.data;
                })
                .finally(() => {});
        },
    },

    // a custom directive to wait for the DOM to be updated
    // before focusing on the input field.
    // http://vuejs.org/guide/custom-directive.html
    directives: {
        "todo-focus": function(el, binding) {
            if (binding.value) {
                el.focus();
            }
        },
    },
};
</script>
